// @mui
import { Stack, Box, Typography, Alert, Tooltip } from '@mui/material';
// layouts
import LoginLayout from '../../layouts/login';
// sections
import AuthLoginForm from './AuthLoginForm';
// locales
import { useLocales } from '../../locales';


// ----------------------------------------------------------------------

export default function Login() {
  const { translate } = useLocales();

  if (localStorage.getItem("tokenEnd")) setTimeout(() => { localStorage.removeItem('tokenEnd') }, 1000);

  return (
    <LoginLayout>

      <Stack spacing={0} sx={{ mt: 0, mb: 4, position: 'relative', flexDirection: 'row' }}>
        <Tooltip title={"Rainbow"} placement="top">
          <Box
            component="img"
            alt={"Rainbow"}
            src={`/assets/logos/rainbowLogo.png`}
            sx={{ mr: '10px', width: 40, height: 40, position: 'relative' }}
          />
        </Tooltip>
        <Typography variant="h4" sx={{ mt: "3px" }}>{translate('login.message')}</Typography>
        {/* <Typography variant="h4" sx={{ mt: "3px" }}>{translate('login.message')}</Typography> */}
      </Stack>

      <AuthLoginForm />

      {localStorage.getItem("tokenEnd") && 
        <>
          <br />
          <Alert severity="warning">{translate('login.tokenExpired')}</Alert>
        </>
      }

    </LoginLayout>
  );
}
